module.exports = __webpack_public_path__ + "src/assets/img/4_4art_1part.b14c400e.jpg";